export default __webpack_public_path__ + "static/media/Exterior (16) copia 2.b22e458f.jpg";